/**
 * Stage badge + risk pill — shared visual primitives for the deployment
 * workflow surfaces (list, detail, dashboard mentions).
 */
import React from "react";
import { cn } from "@/lib/utils";
import { STAGES } from "@/lib/deploymentWorkflow";

const TONE = {
  tralenex: "bg-tralenex-50 text-tralenex-700",
  opp: "bg-opportunity/10 text-opportunity",
  gold: "bg-gold-300/10 text-gold-600",
  low: "bg-risk-low/10 text-risk-low",
};

export function StageBadge({ stageId, terminal, status }) {
  if (terminal && status === "rejected") {
    return (
      <span
        className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold tracking-[0.06em] uppercase bg-risk-high/10 text-risk-high"
        data-testid="deploy-stage-badge"
      >
        Rejected
      </span>
    );
  }
  const stage = STAGES.find((s) => s.id === stageId);
  if (!stage) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold tracking-[0.06em] uppercase",
        TONE[stage.badgeTone] || "bg-inset text-ink-secondary",
      )}
      data-testid="deploy-stage-badge"
    >
      <span className="tabular-nums opacity-70">{stage.id}/7</span>
      {stage.label}
    </span>
  );
}

export function RiskPill({ risk }) {
  const cls = {
    low: "bg-risk-low/10 text-risk-low",
    med: "bg-risk-med/10 text-risk-med",
    high: "bg-risk-high/10 text-risk-high",
  }[risk] || "bg-inset text-ink-secondary";
  return (
    <span
      className={cn(
        "inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold tracking-[0.06em] uppercase",
        cls,
      )}
    >
      {risk} risk
    </span>
  );
}
